import React from "react";
import MainLeft from "./Main/MainLeft";
import MainFilter from "./Main/MainFilter";
import MainBody from "./Main/MainBody";
import ManageBlock from "./Main/ManageBlock";
import { ToastContainer } from "react-toastify";
import { Box } from "@mui/material";

const Main = ({
  // Данные
  responseFilter,
  responseFilmList,

  // Методы и setters
  setSendDataFilmListQueryFilter,
  setManageBlock,
  getDataFilmList,
  getDataListChannels,
  repeatLastFilmListRequest,

  // Block Store
  blockStore,
  manageBlock,
  hideMetUid,
}) => {
  return (
    <Box sx={{ height: "90vh", display: "flex" }}>
      {/* Левая колонка */}
      <MainLeft
        setManageBlock={setManageBlock}
        manageBlock={manageBlock}
        hideMetUid={hideMetUid}
      />

      {/* Правая колонка */}
      <Box sx={{ width: "85%", display: "flex", flexDirection: "column" }}>
        <MainFilter
          responseFilter={responseFilter}
          setSendDataFilmListQueryFilter={setSendDataFilmListQueryFilter}
          getDataFilmList={getDataFilmList}
          manageBlock={manageBlock}
        />

        {/* Основной контент */}
        {!manageBlock && (
          <MainBody
            responseFilmList={responseFilmList}
            getDataFilmList={getDataFilmList}
            repeatLastFilmListRequest={repeatLastFilmListRequest}
            getDataListChannels={getDataListChannels}
            hideMetUid={hideMetUid}
          />
        )}

        {manageBlock && (
          <ManageBlock
            blockStore={blockStore}
            responseFilmList={responseFilmList}
            getDataFilmList={getDataFilmList}
            repeatLastFilmListRequest={repeatLastFilmListRequest}
            getDataListChannels={getDataListChannels}
          />
        )}

        <ToastContainer
          position="top-left"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </Box>
    </Box>
  );
};

export default Main;
